"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.65",
    y: "3.05",
    width: "4.75",
    height: "4.75",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.52",
    y: "3.06",
    width: "4.75",
    height: "4.75",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.55",
    y: "16.19",
    width: "4.75",
    height: "4.75",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.78,1.54H0V9.32H7.78ZM6.27,7.8H1.52V3.06H6.27Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.91,1.54H13.13V9.32h7.78ZM19.39,7.8H14.65V3.05h4.74Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,22.45H7.78V14.67H0Zm1.55-6.26H6.3v4.74H1.55Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.55",
    y: "1.54",
    width: "1.82",
    height: "7.78",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.8,12.44h0a1.61,1.61,0,0,1,.35-.43H6.64v1.75H16l.76-1.32Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.94,12.43h0l.78,1.33h.19V12H19.6A1.74,1.74,0,0,1,19.94,12.43Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "10.25",
    width: "3.69",
    height: "1.75",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "10.01 16.36 10.01 18.12 13.48 18.12 14.52 16.36 10.01 16.36",
    fill: "#004864"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.94,21.91l-4-6.61-1.24-2.13a.35.35,0,0,0-.31-.18.38.38,0,0,0-.31.18l-1.2,2.11-3.11,5.26L12.87,22a.33.33,0,0,0,0,.36.32.32,0,0,0,.31.14H23.64a.37.37,0,0,0,.32-.18A.38.38,0,0,0,23.94,21.91Zm-6.1-6a.57.57,0,0,1,.59-.53.56.56,0,0,1,.58.53v2.9a.55.55,0,0,1-.58.52.56.56,0,0,1-.59-.52Zm.59,5.76a.69.69,0,1,1,.69-.69A.69.69,0,0,1,18.43,21.66Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;